import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { Grid } from '@material-ui/core'
import GrinChip from 'components/common/GrinChip'
import LinkButton from 'components/common/buttons/LinkButton'
import Tooltip from 'components/common/Tooltip'
import { rangeArray } from 'utils/arrayUtils'
import { Skeleton } from '@material-ui/lab'

const LatestScanTaggings = ({ latestScanTimelineItems = [], isLoading }) => {
  const { t } = useTranslation()

  const [visibleConditions, hiddenConditions] = useMemo(() => {
    const unifiedConditions = _.uniq(
      latestScanTimelineItems
        .map(timelineItem => timelineItem.payload.scans.map(scan => scan.offTrackReasons).flat()) // Extract offTrackReasons from each scan
        .flat()
        .map(condition => t(`dialogs.scanSummary.treatmentTracking.conditions.${condition}`))
    )

    return [unifiedConditions.slice(0, 5), unifiedConditions.splice(5)]
  }, [t, latestScanTimelineItems])

  return (
    <div>
      <Grid container spacing={1}>
        {isLoading ? (
          rangeArray(3).map(i => (
            <Grid item key={`loading-condition-${i}`}>
              <Skeleton variant="rect" width={80} height={24} style={{ borderRadius: 4 }} />
            </Grid>
          ))
        ) : (
          <>
            {visibleConditions.map(text => (
              <Grid item key={`condition-${text}`}>
                <GrinChip text={text} />
              </Grid>
            ))}
            {hiddenConditions.length > 0 && (
              <Grid item>
                <Tooltip
                  placement="bottom"
                  variant="light"
                  arrow={true}
                  value={
                    <Grid container spacing={1}>
                      {hiddenConditions.map(text => (
                        <Grid item key={`hidden-condition-${text}`}>
                          <GrinChip text={text} />
                        </Grid>
                      ))}
                    </Grid>
                  }
                >
                  <LinkButton
                    fontSize={13}
                    underline
                    label={t(
                      'pages.patients.patientSidebar.items.copilot.copilotInsights.scanInsights.moreConditions',
                      {
                        count: hiddenConditions.length
                      }
                    )}
                  />
                </Tooltip>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </div>
  )
}

export default LatestScanTaggings
